import { PresetMetadataOptions, setPresetMetadataOn } from './preset';
/**
 * @param {?=} options
 * @return {?}
 */
export function Preset(options?: PresetMetadataOptions): PropertyDecorator {
  return (target, propName) =>
    setPresetMetadataOn(target, {
      propName,
      options,
    });
}
